export class Certificate {
  constructor(
    public learnerCertificates: any[]
  ) {  }
}
export class PreviewCertificate{
  constructor(
    public certificateDTO: Certificate
  ){ }
}



// WEBPACK FOOTER //
// ./src/app/core/components/content/certificate/certificate.ts